import { Typography } from "@mui/material";
import { CONTRACT_STATUS_COLOR_MAP } from "@synota-io/synota-shared-ui";
import { IDashboardContract } from "../../../../api/hooks/useContracts";

export const ContractStatusTextCell = ({ contract }: { contract: IDashboardContract }) => {
  if (!contract.contract_state) {
    return null;
  }
  return (
    <Typography
      variant="inherit"
      component="span"
      color={CONTRACT_STATUS_COLOR_MAP[contract.contract_state]}
    >
      {contract.contract_state}
    </Typography>
  );
};
